export const RouterOrder = [
  {
    path: "/order", // 订单
    name: "订单",
    component: (resolve) => require(/* webpackChunkName: "order" */ ["@/views/orders/Index"], resolve),
  },
  {
    path:"/erCode",
    name: "电子二维码",
    component: (resolve) => require(/* webpackChunkName: "order" */ ["@/views/orders/ErCode"], resolve),
  }
];
